export const PARTNER_SIGNUP_GETTING_STARTED_TEXT = "getting_started";
export const PARTNER_SIGNUP_BASIC_INFORMATION_TEXT = "basic_information";
export const PARTNER_SIGNUP_LOCATION_TEXT = "location";
export const PARTNER_SIGNUP_TELL_US_ABOUT_YOUR_SELF_TEXT =
  "tell_us_about_yourself";
export const PARTNER_SIGNUP_SERVICES_AND_TOOLS_TEXT = "services_&_availability";
export const PARTNER_SIGNUP_REQUEST_RECEIVED_TEXT = "request_received";
export const PARTNER_SIGNUP_GETTING_STARTED = 1;
export const PARTNER_SIGNUP_BASIC_INFORMATION = 2;
export const PARTNER_SIGNUP_LOCATION = 3;
export const PARTNER_SIGNUP_TELL_US_ABOUT_YOUR_SELF = 4;
export const PARTNER_SIGNUP_SKILLS_AND_TOOLS = 5;
export const PARTNER_SIGNUP_REQUEST_RECEIVED = 3;
export const PARTNER_SIGNUP_WELCOME_MESSAGE = "Welcome Advisors!";
